export const SHOP = {
  name: "New Shivam Medicos",
  tagline: "Your Health, Our Priority",
  phone: "+91 8876499294",
  phoneTel: "+918876499294",
  whatsapp: "918876499294",
  address: "South Basistha Nagar, near Durga Mandir, Basistha, Guwahati, Assam",
  hours: "8:30 AM – 2 PM · 4 PM – 10:00 PM",
  hoursShort: "Mon – Sun",
  mapsUrl: "https://g.co/kgs/h3d5zFG",
};
